import React, { useState } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

function AddSubscriptionModal({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    validity_days: "",
    original_price: "",
    sell_price: "",
    expiry_date: "",
    allowed_number_of_devices: "",
    status: "",
    description: "",
  });

  const [message, setMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");


  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const {
      name,
      validity_days,
      original_price,
      sell_price,
      expiry_date,
      allowed_number_of_devices,
      status,
      description,
    } = formData;

    if (!name || !validity_days || !original_price || !sell_price || !expiry_date || !allowed_number_of_devices || !status || !description) {
      setMessage("Please fill in all fields.");
      setSnackbarType("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const data = new FormData();
      data.append("name", name);
      data.append("validity_days", validity_days);
      data.append("original_price", original_price);
      data.append("sell_price", sell_price);
      data.append("expiry_date", expiry_date);
      data.append("allowed_number_of_devices", allowed_number_of_devices);
      data.append("status", status);
      data.append("description", description);

      const token = localStorage.getItem("access_token");

      if (!token) {
        setMessage("Access token not found. Please log in again.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/subscription`,
        data,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === false) {
        setMessage(response.data.message);
        setSnackbarType("error");
        setSnackbarOpen(true);
        return;
      }

      setMessage("Subscription added successfully!");
      setSnackbarType("success");
      setSnackbarOpen(true);

      setFormData({
        name: "",
        validity_days: "",
        original_price: "",
        sell_price: "",
        expiry_date: "",
        allowed_number_of_devices: "",
        status: "",
        description: "",
      });

      setTimeout(() => {
        setMessage("");
        setSnackbarOpen(false);
        onClose();
      }, 1000);
    } catch (error) {
      console.error("Error adding subscription:", error);
      setMessage(error.response?.data?.message || "Failed to add subscription. Please try again.");
      setSnackbarType("success");
      setSnackbarOpen(true);

    }
  };
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };


  return (
    <MDBox component="form" role="form" onSubmit={handleSubmit} p={3}>
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#999",
        }}
        title="Close"
      >
        &times;
      </div>

      <MDTypography variant="h5" fontWeight="medium" mb={3}>
        Add Subscription
      </MDTypography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <MDInput label="Name" name="name" fullWidth value={formData.name} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            type="number"
            label="Validity (days)"
            name="validity_days"
            fullWidth
            value={formData.validity_days}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <MDInput
            type="number"
            label="Original Price"
            name="original_price"
            fullWidth
            value={formData.original_price}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            type="number"
            label="Sell Price"
            name="sell_price"
            fullWidth
            value={formData.sell_price}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <MDInput
            type="date"
            label="Expiry Date"
            name="expiry_date"
            fullWidth
            value={formData.expiry_date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            type="number"
            label="Allowed Devices"
            name="allowed_number_of_devices"
            fullWidth
            value={formData.allowed_number_of_devices}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} >
          <MDTypography variant="button" fontWeight="regular" display="block" mb={1}>
            Status
          </MDTypography>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "5px",
              backgroundColor: "#fff",
            }}
          >
            <option value="">Select status</option>
            <option value="0">Active</option>
            <option value="1">Inactive</option>
          </select>
        </Grid>

        <Grid item xs={12}>
          <MDInput
            label="Description"
            name="description"
            fullWidth
            multiline
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
        </Grid>
      </Grid>


      <MDBox mt={4} mb={1}>
        <MDButton variant="gradient" color="info" type="submit" fullWidth>
          Add Subscription
        </MDButton>
      </MDBox>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarType}
          sx={{ width: "100%" }}
        >
          {message}
        </MuiAlert>
      </Snackbar>
    </MDBox>
  );
}

export default AddSubscriptionModal;
